export const TABLE_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const tablePaginationState = () => ({
  table_search: '',
  table_page: 1,
  table_page_size: 10,
  table_page_size_options: TABLE_PAGE_SIZE_OPTIONS
});

export const tablePaginationComputed = {
  table_total_pages() {
    const total = Number(this.table_total_rows || 0);
    const page_size = Number(this.table_page_size || 10);
    return Math.max(1, Math.ceil(total / page_size));
  },
  table_page_start() {
    if (!this.table_total_rows) return 0;
    return ((this.table_page - 1) * this.table_page_size) + 1;
  },
  table_page_end() {
    return Math.min(this.table_page * this.table_page_size, this.table_total_rows || 0);
  }
};

export const tablePaginationMethods = {
  normalize_table_search_value(value) {
    return String(value || '').trim().toLowerCase();
  },
  get_table_search_text(row) {
    if (!row || typeof row !== 'object') return String(row || '');

    const values = Object.values(row)
      .filter((value) => ['string', 'number', 'boolean'].includes(typeof value));

    return values.join(' ');
  },
  table_row_matches_search(row) {
    const search = this.normalize_table_search_value(this.table_search);
    const row_text = this.normalize_table_search_value(this.get_table_search_text(row));

    return !search || row_text.includes(search);
  },
  filter_table_rows(rows = []) {
    const safe_rows = Array.isArray(rows) ? rows : [];

    return safe_rows.filter((row) => this.table_row_matches_search(row));
  },
  paginate_table_rows(rows = []) {
    const safe_rows = Array.isArray(rows) ? rows : [];
    const page_size = Number(this.table_page_size || 10);
    const current_page = Math.min(Math.max(Number(this.table_page || 1), 1), Math.max(1, Math.ceil(safe_rows.length / page_size)));
    const start = (current_page - 1) * page_size;
    return safe_rows.slice(start, start + page_size);
  },
  set_table_page_size(size) {
    this.table_page_size = Number(size) || 10;
    this.table_page = 1;
  },
  set_table_page(page) {
    this.table_page = Math.min(Math.max(Number(page) || 1, 1), this.table_total_pages);
  },
  reset_table_page() {
    this.table_page = 1;
  }
};
